import axios from 'axios';

let prefix = "/email-blast"

const EmailBlastApi = {
	getEmailBlastUsers(payload){
		return axios.get( prefix + "/users", {params: payload})
	},
	sendEmailBlast(payload){
		return axios.post( prefix + "/send", payload)
	},
}

export default EmailBlastApi;
